var _rect, _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBotim(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 100,
    height: 100,
    rx: 30,
    fill: "#808080"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 42.9688,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9615 43.6533C48.9551 43.6533 50.9039 44.2445 52.5615 45.3521C54.2191 46.4596 55.511 48.0338 56.2739 49.8757C57.0368 51.7175 57.2364 53.7442 56.8475 55.6994C56.4586 57.6547 55.4986 59.4507 54.0889 60.8604C52.6792 62.2701 50.8832 63.2301 48.928 63.619C46.9727 64.0079 44.946 63.8083 43.1042 63.0454C41.2624 62.2825 39.6881 60.9905 38.5806 59.333C37.473 57.6754 36.8818 55.7266 36.8818 53.733C36.8818 51.0597 37.9438 48.4959 39.8341 46.6056C41.7244 44.7153 44.2882 43.6533 46.9615 43.6533Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.0057 43.6533C82.9993 43.6533 84.9481 44.2445 86.6057 45.3521C88.2633 46.4596 89.5552 48.0338 90.3181 49.8757C91.081 51.7175 91.2806 53.7442 90.8917 55.6994C90.5028 57.6547 89.5428 59.4507 88.1331 60.8604C86.7234 62.2701 84.9274 63.2301 82.9721 63.619C81.0169 64.0079 78.9902 63.8083 77.1484 63.0454C75.3066 62.2825 73.7323 60.9905 72.6248 59.333C71.5172 57.6754 70.926 55.7266 70.926 53.733C70.926 51.0597 71.988 48.4959 73.8783 46.6056C75.7686 44.7153 78.3324 43.6533 81.0057 43.6533Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotim);
export default __webpack_public_path__ + "static/media/Botim.e1b3c46bfcaafd8a09c9ebf7ac782fb6.svg";
export { ForwardRef as ReactComponent };